import React from 'react';
import { SvgIcon, IconName } from '@adjust/dashboard-components';

export const Info: React.FC = ({ children }) => (
  <div className="info">
    <SvgIcon name={IconName.InfoRound} /> {children}
  </div>
);
